import { IRole } from '@nkr/models/role';
import { AuthEntityType } from '@nkr/enums/index';
import { Alert, Button, FormControl, Label, Modal } from 'react-bootstrap';
import { ICounselor, IDuplicate } from './models';
import { DuplicatesTableWrapper } from './styles';

interface IProps {
    show: boolean,
    email: string,
    phoneNumber: string,
    data: IDuplicate[],
    roles: IRole[],
    mentorList: ICounselor[],
    container: any,
    onMentorChange: (id: number, userId: number) => void,
    onUpdate: () => void,
    onClose: () => void
}

const Duplicates = (props: IProps) => {
    const handleMentorChange = (id: number, userId: number) => {
        props.onMentorChange(id, userId);
    };

    const getAllowMentorToChange = (data: IDuplicate) => {
        let donorGroups = props.roles.filter(x => x.entityType == AuthEntityType.DonorConnect).map(x => x.entityTypeId);
        let allowMentorChange = donorGroups.indexOf(data.connectToDonorGroupId) >= 0;

        return allowMentorChange;
    };

    const disableUpdate = props.data.filter(x => x.connectToDonorAssignedUserId != x.newMentorId).length == 0;

    return (
        <>
        <style>{'.duplicates-modal { width: 90%; max-width: 1200px; }'}</style>
        <Modal backdrop='static' bsSize='lg' dialogClassName='duplicates-modal' show={props.show} onHide={props.onClose} container={props.container}>
            <Modal.Header closeButton>
                Duplicates for Email [<strong>{props.email}</strong>] or Phone Number [<strong>{props.phoneNumber}</strong>]
            </Modal.Header>
            <Modal.Body>
                <Alert bsStyle='info' style={{ paddingTop: 7.5, paddingBottom: 7.5 }}>There are multiple DASH registrations that match the email address or phone number...</Alert>

                <DuplicatesTableWrapper condensed>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Email</th>
                            <th>Phone #</th>
                            <th>Center</th>
                            <th>Group</th>
                            <th>Mentor</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.data.map((item, index) => {
                            let allowMentorChange = getAllowMentorToChange(item);

                            return (
                                <tr key={'dupe-' + index}>
                                    <td>{item.id}</td>
                                    <td>{item.firstName}</td>
                                    <td>{item.lastName}</td>
                                    <td>{item.email}</td>
                                    <td>{item.phoneNumber}</td>
                                    <td>{item.centerAlias != null ? item.centerAlias : <>[Not Selected]</>}</td>
                                    <td>{item.connectToDonorGroup}</td>
                                    <td>
                                        {allowMentorChange ?
                                            <FormControl
                                                componentClass='select'
                                                bsSize='sm'
                                                value={item.newMentorId}
                                                onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => handleMentorChange(item.id, parseInt(e.currentTarget.value))}
                                            >
                                                <option value={0}>- Select -</option>
                                                {props.mentorList.map(mentor =>
                                                    <option key={'mentor-' + mentor.id} value={mentor.id}>{mentor.firstName} {mentor.lastName}</option>
                                                )}
                                            </FormControl>
                                            :
                                            <>
                                                {item.connectToDonorAssigndUser != null ?
                                                    <>{item.connectToDonorAssigndUser.firstName} {item.connectToDonorAssigndUser.lastName}</>
                                                    :
                                                    <><Label style={{ fontSize: '100%' }}>Assigned by {item.connectToDonorGroup}</Label></>
                                                }
                                            </>
                                        }
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </DuplicatesTableWrapper>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' disabled={disableUpdate} onClick={props.onUpdate}>Update Mentor Assignments</Button>
                <Button onClick={props.onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
        </>
    );
}

export default Duplicates;